<template>
  <div class="AddriskPointIdentificationBox">
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'ProcessRiskPoint' }">风险点</el-breadcrumb-item>
        <el-breadcrumb-item>辨识</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.query.id ? '新增' : '编辑' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" style="width: 60%;margin: auto" size="small">
        <el-form-item label="风险点" prop="riskClassificationId">
          <el-select v-model="ruleForm.riskClassificationId" style="width: 100%" :disabled="true">
            <el-option v-for="item in riskPointList" :key="item.id" :label="item.riskName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="depId">
          <el-select v-model="ruleForm.depId" style="width: 100%" :disabled="true">
            <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="辨识名称" prop="name">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 5px">
          <el-col :span="12">
            <el-form-item label="责任人" prop="responsibleEmpId">
              <el-select v-model="ruleForm.responsibleEmpId" style="width: 100%">
                <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人电话" prop="responsiblePhone">
              <el-input v-model="ruleForm.responsiblePhone" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="审核人" prop="auditEmpId">
          <el-select v-model="ruleForm.auditEmpId" style="width: 100%">
            <el-option v-for="item in userList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="现场照片" prop="localePicture">
          <el-upload
            class="avatar-uploader"
            action="/v1/hiddenGovern/uploadBuildingFile"
            :show-file-list="false"
            accept=".jepg,.jpg,.png,gif,"
            :on-success="handleAvatarSuccess">
            <img v-if="ruleForm.localePicture" :src="host + ruleForm.localePicture" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="指示标示" prop="sign">
          <el-select v-model="ruleForm.sign" style="width: 100%">
            <el-option v-for="item in signList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <!--<el-form-item label-width="0" style="margin-bottom: 5px">
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="ruleForm.longitude" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="ruleForm.latitude" />
            </el-form-item>
          </el-col>
           <el-col :span="4" style="text-align: right">
            <el-button @click="getPosition">点击自动获取</el-button>
          </el-col>
        </el-form-item>-->
        <el-form-item label="排查项目/作业步骤">
          <el-button type="primary" @click="openDia">添加</el-button>
          <!-- JAH的表格 -->
          <el-table :data="tableData" style="width: 100%">
            <el-table-column type="index" :index='(index) => {return index + 1}' label="序号" width="50" />
            <el-table-column prop="project" :label="analyticalMethodClassify === 1 ? '作业步骤' : '排查项目'" />
            <el-table-column prop="riskFactor" label="风险要素"/>
            <el-table-column prop="name" :label="analyticalMethodClassify === 1 ? '风险源、潜在事件' : '标准'" />
            <el-table-column prop="riskDescription" :label="analyticalMethodClassify === 1 ? '可能发生的事故描述' : '不符合标准状况'" />
            <el-table-column prop="type" label="易发事故类型" />
            <el-table-column prop="consequence" label="后果" />
            <el-table-column label="操作" width="90">
              <template slot-scope="{ row }">
                <el-link :underline="false" type="primary" @click="tableEdit(row)">编辑</el-link>
                <span> | </span>
                <el-link :underline="false" type="danger" @click="tableDelete(row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- SCL的表格 -->
          <!-- <el-table :data="tableDataS" style="width: 100%">
            <el-table-column type="index" :index='(index) => {return index + 1}' label="序号" width="50" />
            <el-table-column prop="project" label="排查项目" width="80" />
            <el-table-column prop="name" label="标准" />
            <el-table-column prop="riskDescription" label="不符合标准状况" />
            <el-table-column prop="type" label="易发事故类型" />
            <el-table-column prop="consequence" label="后果" />
            <el-table-column label="操作" width="80">
              <template slot-scope="{ row }">
                <el-link :underline="false" type="primary">编辑</el-link>
                <el-link :underline="false" type="error">删除</el-link>
              </template>
            </el-table-column>
          </el-table> -->
        </el-form-item>
        <el-form-item label="相关资料">
          <!-- 相关资料保存的字段 -->
          <!-- relevantFileName， relevantFileUrl -->
          <el-upload
            class="upload-demo"
            action="/v1/modifyform/uploadFile/1"
            :on-remove="handleRemove"
            :limit="1"
            :on-exceed="handleExceed"
            :on-change="handleChange"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" v-model="ruleForm.remark" />
        </el-form-item>
        <el-form-item label="" style="margin-top: 40px">
          <el-button type="primary" style="width: 100%" @click="submitForm">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 风险源、潜在事件的弹窗 -->
    <el-dialog title="添加" :visible.sync="dialogFormVisible" @close="closeDia" width="30%" class="innerDia">
      <el-form :model="diaForm" ref="diaForm" :rules="diaRules" size="small" label-width="90px">
        <el-form-item prop="project" :label="analyticalMethodClassify === 1 ? '作业步骤' : '排查项目'">
          <el-input v-model="diaForm.project"  />
        </el-form-item>
        <el-form-item prop="name" :label="analyticalMethodClassify === 1 ? '风险源、潜在事件' : '标准'">
          <el-input v-model="diaForm.name" />
        </el-form-item>
        <el-form-item prop="riskFactor" label="风险要素">
          <el-select v-model="diaForm.riskFactor" style="width: 100%">
            <el-option v-for="y in riskFactorList" :key="y" :label="y" :value="y" />
          </el-select>
        </el-form-item>
        <el-form-item prop="type" label="易发事故类型">
          <!-- <el-select v-model="diaForm.type" style="width: 100%">
            <el-option v-for="item in riskDescriptionList" :key="item" :value="item" :label="item" />
          </el-select> -->
          <el-input v-model="diaForm.type" />
        </el-form-item>
        <el-form-item prop="riskDescription" :label="analyticalMethodClassify === 1 ? '可能发生的事故描述' : '不符合标准状况'">
          <!-- <el-input v-model="diaForm.riskDescription" type="textarea" :rows="2" /> -->
          <el-input v-model="diaForm.riskDescription" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item prop="consequence" label="后果">
          <el-input v-model="diaForm.consequence" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDia" size="small">取 消</el-button>
        <el-button type="primary" @click="tablePush" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { riskPointDetail, getStaffList, riskIdentifyAdd, getAllDepartment, getRiskPointList,
 riskIdentifyEdit } from '@/api/processManager'
import axios from 'axios'
export default {
  name: 'AddriskPointIdentification',
  data() {
    return {
      ruleForm: {
        localePicture: ''
      },
      // 存储分析方法分类 来控制下面的表格的表头显示
      analyticalMethodClassify: '',
      rules: {
        // riskClassificationId: [{ required: true, trigger: 'blur' }],
        // depId: [{ required: true, trigger: 'blur' }],
        name: [{ required: true, message: '请输入辨识名称', trigger: 'blur' }],
        responsibleEmpId: [{ required: true, message: '请选择责任人', trigger: 'change' }],
        responsiblePhone: [{ required: true, message: '请输入责任人电话号码', trigger: 'blur' }],
        auditEmpId: [{ required: true, message: '请选择审核人', trigger: 'change' }],
        localePicture: [{ required: true, message: '请上传照片', trigger: 'blur' }],
        sign: [{ required: true, message: '请选择指示标志', trigger: 'change' }],
        /*longitude: [{ required: true, message: '请填写经度', trigger: 'blur' }],
        latitude: [{ required: true, message: '请填写纬度', trigger: 'blur' }]*/
      },
      signList: [
        { id: 1, name: '指示标志' },
        { id: 2, name: '警示作业安全警示标志' },
        { id: 3, name: '逃生避难警示标志' },
        { id: 4, name: '风向指示标' }
      ],
      // 风险点列表
      riskPointList: [],
      // 部门列表
      departList: [],
      // 人员的列表
      userList: [],
      // 上传资料的数组
      fileList: [],
      // 风险源、潜在事件的表格
      tableData: [],
      // 风险源、潜在事件的弹窗表单
      diaForm: {
        project: '',
        name: '',
        riskDescription: '',
        type: '',
        consequence: ''
      },
      // 可能发生事故描述的数组
      riskDescriptionList: ['物体打击','车辆伤害','机械伤害','起重伤害','触电','淹溺','灼烫','火灾','高处坠落','坍塌','锅炉爆炸','容器爆炸','其它爆炸','中毒','窒息','其它伤害'],
      // 风险要素的数组
      riskFactorList: ['人的因素','物体因素','环境因素','管控因素'],
      diaRules: {
        project: [{ required: true, message: '请输入' }],
        name: [{ required: true, message: '请输入' }],
        riskFactor: [{ required: true, message: '请选择' }],
        riskDescription: [{ required: true, message: '请选择' }],
        type: [{ required: true, message: '请输入' }],
        consequence: [{ required: true, message: '请输入' }]
      },
      dialogFormVisible: false,
    }
  },
  created() {
    this.getAllEmp();
    this.getDepart();
    this.getRiskPointList();
    // 新增
    if(this.$route.query.id) {
      riskPointDetail(this.$route.query.id).then(res => {
        this.analyticalMethodClassify = res.body.data.analyticalMethodClassify
        this.$nextTick(() => {
          this.ruleForm.riskClassificationId = Number(this.$route.query.id)
          this.ruleForm.depId = res.body.data.depId
        })
      })
    }
    // 编辑
    if(this.$route.params.data) {
      riskPointDetail(this.$route.params.data.riskClassificationId).then(res => {
        this.analyticalMethodClassify = res.body.data.analyticalMethodClassify
        this.ruleForm = this.$route.params.data;
        this.tableData = this.$route.params.data.measure
        if(this.ruleForm.relevantFileUrl) {
          this.fileList.push({ 
            name: this.ruleForm.relevantFileName,
            response: { data: this.ruleForm.relevantFileUrl }
          })
        }
      })
    }
  },
  mounted(){
    this.getPosition()
  },
  methods: {
    // 上传现场照片的事件
    handleAvatarSuccess(res, file) {
      // this.ruleForm.localePicture = res.data;
      this.$set(this.ruleForm, 'localePicture', res.data)
    },
    // 上传资料的事件
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    handleExceed(file, fileList) {
      this.$message.warning('限制上传一个文件')
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    // 获取所有员工
    getAllEmp() {
      getStaffList().then(res => {
        this.userList = res.body.data;
      })
    },
    // 获取所有部门的列表
    getDepart() {
      getAllDepartment().then(res => {
        this.departList = res.body.data
      })
    },
    // 获取分险点数据
    getRiskPointList() {
      getRiskPointList({ limit: 1000, curPage: 1 }).then(res => {
        this.riskPointList = res.body.data;
      })
    },
    // 获取经纬度
    getPosition() {
    //   axios({
    //     url: '/jingweidu/location/ip?ak=HQi0eHpVOLlRuIFlsTZNGlYvqLO56un3&coor=bd09ll',
    //     type: 'POST',
    //     dataType: 'JSONP',
    //     async: false,
    //     cache: true,
    //     success: function (data) {
    //       console.log(data)
    //     },
    //     error: function (data) {
    //     }
    //   })
    },
    // 打开弹窗的按钮
    openDia() {
      this.dialogFormVisible = true;
    },
    // 关闭弹窗
    closeDia() {
      this.$refs['diaForm'].resetFields();
      this.diaForm = {
        project: '',
        name: '',
        riskDescription: '',
        type: '',
        consequence: ''
      }
      this.dialogFormVisible = false;
    },
    // 弹窗的确认按钮，把表单的数据添加到表格里面去
    tablePush() {
      this.$refs['diaForm'].validate((valid) => {
        if (valid) {
          // 添加
          if(!this.diaForm.id) {
            this.tableData.push({ id: parseInt(Math.random()*1000 - 1000), ...this.diaForm });
          }else{
            // 编辑
            for(let i in this.tableData) {
              if(this.tableData[i].id === this.diaForm.id) {
                this.tableData[i].project = this.diaForm.project
                this.tableData[i].name = this.diaForm.name
                this.tableData[i].riskDescription = this.diaForm.riskDescription
                this.tableData[i].type = this.diaForm.type
                this.tableData[i].consequence = this.diaForm.consequence
              }
            }
          }
          this.closeDia();
        } else {
          return false;
        }
      });
    },
    // 表格删除
    tableDelete(row) {
      let arr = this.tableData;
      for(let i in arr) {
        if(arr[i].id === row.id) {
          this.tableData.splice(i, 1)
          return
        }
      } 
    },
    // 表格编辑
    tableEdit(row) {
      this.diaForm = { ...row };
      this.openDia();
    },
    // 提交整个表单
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if(this.fileList.length > 0) {
            this.ruleForm.relevantFileName = this.fileList[0].name
            this.ruleForm.relevantFileUrl = this.fileList[0].response.data
          }
          if(this.tableData.length === 0) {
            this.$message.warning('请填写“排查项目，作业步骤”');
            return
          }else{
            let obj = { ...this.ruleForm, measure: this.tableData }
            // 新增
            if(this.$route.query.id) {
              riskIdentifyAdd({ ...obj }).then(res => {
                this.$message.success('保存成功');
                this.$router.push('twoOrderNew')
              })
            // 编辑
            } else if (this.$route.params.data) {
              riskIdentifyEdit({ ...obj }).then(res => {
                this.$message.success('保存成功');
                this.$router.push('twoOrderNew')
              })
            }
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.AddriskPointIdentificationBox /deep/ .el-dialog__body {
  padding-bottom: 5px
}
.AddriskPointIdentificationBox .innerDia /deep/ .el-form-item--small .el-form-item__label {
  line-height: 20px
} 
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>